
import React from "react";
import styles from './BottomNavMobile.module.css';


// external dependencies
import { BsSave2 } from 'react-icons/bs';
import { RxDashboard } from 'react-icons/rx';
// import { HiOutlineLogout } from 'react-icons/hi';
import { FiSettings, FiUser } from 'react-icons/fi';
import { RiNotificationBadgeLine } from 'react-icons/ri';
import { NavLink } from 'react-router-dom';
import { BiSupport } from 'react-icons/bi';

const BottomNavMobile = ()=>{

    const activeStyle = {
        color: '#833AB4',
        fontWeight: 'bolder',
    };

    return(<div className={styles.BottomNavMobile_wrapper}>
        
        <section className={styles.bottom_nav_un_ordered__}>


            <article className={styles.bottom_nav_li__}>
                <NavLink to={'support'} style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  } className={styles.liiiiink_colo}>
                    <BiSupport className={styles.bottom_icons_size__} />
                </NavLink>
            </article>


            <article className={styles.bottom_nav_li__}>
                <NavLink to={'invest'} style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  } className={styles.liiiiink_colo}>
                    <BsSave2 className={styles.bottom_icons_size__} />
                </NavLink>
            </article>

            <article className={styles.bottom_nav_li__}>
                <NavLink to={'dashboard'} style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  } className={styles.liiiiink_colo}>
                    <RxDashboard className={`${styles.bottom_icons_size__} ${styles.bigger_home_icon_}`} />
                </NavLink>
            </article>

            <article className={styles.bottom_nav_li__}>
                <NavLink to={'notifications'} style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  } className={styles.liiiiink_colo}>
                    <RiNotificationBadgeLine className={styles.bottom_icons_size__} />
                </NavLink>
            </article>


            <article className={styles.bottom_nav_li__}>
                <NavLink to={'settings'} style={({ isActive }) =>
                    isActive ? activeStyle : undefined
                  } className={styles.liiiiink_colo}>
                    <FiSettings className={styles.bottom_icons_size__} />
                </NavLink>
            </article>


        </section>

    </div>)
}

export default BottomNavMobile;